import moment from 'moment';
import router from '@/router/index';
import AccountService from '@/api/AccountService';
import TokenService from '@/api/TokenService';
import MemberService from '@/api/MemberService';

const state = {
  isLoggedIn: false,
  username: '',
  token: '',
  refreshToken: '',
};

const getters = {};

const actions = {
  init({ commit }) {
    if (localStorage.getItem('store/user/token')) {
      commit('login', {
        token: localStorage.getItem('store/user/token'),
        username: localStorage.getItem('store/user/username'),
        refreshToken: localStorage.getItem('store/user/refreshToken'),
      });
    }
  },
  login({ commit }, args) {
    const today = moment().toDate();
    return TokenService.token(args.username, args.password).then((response) => {
      if (!response.data.error) {
        Object.assign(response.data, { username: args.username });
        commit('login', response.data);

        return MemberService.getCurrentMember().then((response2) => {
          AccountService.passwordExpiration().then((response3) => {
            if (response3.data.expirationDateTime) {
              const expDate = new Date(response3.data.expirationDateTime);
              const timeDiff = Math.abs(today.getTime() - expDate.getTime());
              const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
              if (diffDays < 6) {
                commit(
                  'alerts/setAlert',
                  {
                    msg: 'LOGIN.PASSWORD_EXPIRATION',
                    args: [diffDays, diffDays > 1 ? 's' : ''],
                  },
                  { root: true },
                );
              }
            }
          });
          if (!response2.data.hasContactInformation) {
            return router.push(
              '/dashboard/profile/account/contact-information',
            );
          }

          if (router.currentRoute.query.rurl) {
            return router.push(decodeURI(router.currentRoute.query.rurl));
          }
          return router.push('/dashboard');
        });
      }
      return null;
    });
  },
  refresh({ state, commit }) {
    return TokenService.refreshToken(state.username, state.refreshToken).then(
      (response) => {
        Object.assign(response.data, { username: state.username });
        commit('login', response.data);
        return null;
      },
      () => {
        commit('logout');
        return router.push('/');
      },
    );
  },
  logout({ commit }) {
    commit('logout');
    router.push('/');
    commit(
      'alerts/setAlert',
      {
        msg: 'LOGOUT.CONFIRMATION_MESSAGE',
      },
      { root: true },
    );
  },
  forgotPassword({ commit }, args) {
    return AccountService.forgotPassword(args.email).then((response) => {
      if (!response.data.error) {
        commit(
          'alerts/setAlert',
          {
            msg: 'FORGOT_PASSWORD.CONFIRMATION_MESSAGE',
          },
          { root: true },
        );
      }
    });
  },
  resetPassword({ commit }, args) {
    return AccountService.resetPassword(
      args.userId,
      args.code,
      args.password,
    ).then((response) => {
      if (!response.data.error) {
        commit(
          'alerts/setAlert',
          {
            msg: 'RESET_PASSWORD.CONFIRMATION_MESSAGE',
          },
          { root: true },
        );
        router.push('/');
      }
    });
  },
};

const mutations = {
  login(state, payload) {
    localStorage.setItem('store/user/token', payload.token);
    localStorage.setItem('store/user/refreshToken', payload.refreshToken);
    localStorage.setItem('store/user/username', payload.username);

    state.isLoggedIn = true;
    state.refreshToken = payload.refreshToken;
    state.token = payload.token;
    state.username = payload.username;
  },

  logout(state) {
    localStorage.removeItem('store/user/token');
    localStorage.removeItem('store/user/refreshToken');
    localStorage.removeItem('store/user/username');

    state.isLoggedIn = false;
    state.refreshToken = null;
    state.token = null;
    state.username = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
